import { BASE_URL } from './config'

async function fetchWithHandling(url: string, options: RequestInit) {
  const response = await fetch(url, options)
  if (!response.ok) {
    let errorMessage = 'An error occurred'
    try {
      const errorData = await response.json()
      errorMessage = errorData.message || errorMessage
    } catch (e) {
      errorMessage = response.statusText
    }
    throw new Error(errorMessage)
  }
  return response.json()
}

export async function getAppointments(
  token: string,
  filters?: { from?: string; to?: string },
) {
  const params = new URLSearchParams()
  if (filters?.from) params.append('from', filters.from)
  if (filters?.to) params.append('to', filters.to)

  const queryString = params.toString() ? `?${params.toString()}` : ''

  return fetchWithHandling(`${BASE_URL}/api/v1/appointments${queryString}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export async function createAppointment(
  token: string,
  data: {
    title: string
    appointmentDate: string
    location?: string
    doctorName?: string
    notes?: string
  },
) {
  return fetchWithHandling(`${BASE_URL}/api/v1/appointments`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
}

export async function updateAppointment(
  token: string,
  id: string,
  data: Partial<{
    title: string
    appointmentDate: string
    location: string
    doctorName: string
    notes: string
  }>,
) {
  return fetchWithHandling(`${BASE_URL}/api/v1/appointments/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
}

export async function deleteAppointment(token: string, id: string) {
  return fetchWithHandling(`${BASE_URL}/api/v1/appointments/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}
